import { ContentType } from "@lib/content";


export type MatchReason =
  | 'TITLE_MATCH'
  | 'ORIGINAL_TITLE_MATCH'
  | 'AKA_MATCH'
  | 'WORKING_TITLE_MATCH'
  | 'IMDB_MATCH'
  | 'TITLE_CONTENT_TYPE_MATCH';

  export const MATCH_REASON_LABELS: Record<string, string> = {
  IMDB_MATCH: 'IMDb Match',
  TITLE_MATCH: 'Title Match',
  ORIGINAL_TITLE: 'Original Title',
  AKA_MATCH: 'AKA',
  WORKING_TITLE: 'Working Title',
  TITLE_CONTENT_TYPE_MATCH: 'Title + Content Type',
};

  export const CONTENT_TYPE_LABELS: Partial<Record<ContentType, string>> = {
  [ContentType.MOVIE]: 'Movie',
  [ContentType.SERIES]: 'TV Series',
  [ContentType.MICROSERIES]: 'Microseries',
};

export interface ContentRecord {
  vtr_id: string;

  title?: string;
  original_title?: string;
  content_aka?: string;
  working_title?: string;

  content_type?: number;
  genres?: string;
  imdb_id?: string;
  lang_names?: string;
  origin_country?: string;
  release_date?: string;
  created_at?: string;
  modified_at?: string;

  status?: string;
  vtr_content_status?: string;
  poster_path?: string | null;
  [key: string]: any;
}


export interface DuplicateGroup {
  id: string;
  groupKey: string;
  records: ContentRecord[];
  matchReasons?: MatchReason[];
  createdBy?: string;
  createdAt?: string;
  sourceGroupVtrIds?: string[];
}

export interface ContentData {
  title: string;
  original_title: string;
  content_aka: string;
  working_title: string;
  imdb_id: string;
  content_type: number;
}

export interface DuplicateDecisionContent {
  title: string;
  original_title: string | null;
  content_aka: string | null;
  working_title: string;
  imdb_id: string | null;
  content_type: number;
  lang_names?: string;
  origin_country?: string;
}

export interface DuplicateDecision {
  content_data?: Record<string, DuplicateDecisionContent>;
  latest_content_data?: Record<string, DuplicateDecisionContent>;

  group_vtr_ids: string[];
  match_reasons: string[];

  pair_key: string;

  vtr_id_1: string;
  vtr_id_2: string;

  created_by: string;
  created_at: string;

  // If your latest API actually returns this:
  selected_vtr_ids?: string[];
}

export interface NonDuplicateGroup {
  id: string;
  vtrIds: string[];

  contents: {
    vtrId: string;
    title: string;
    originalTitle: string;
    contentAka: string;
    workingTitle: string;
    imdbId: string;
    contentType: number;
  }[];

  matchReasons: string[];

  createdBy: string;
  createdAt: string;
}

export interface DuplicateDecisionRequest {
  selected_vtr_ids: string[];
  match_reasons: string[];
  group_vtr_ids: string[];
  content_data: Record<string, {
    title: string;
    original_title: string;
    content_aka: string;
    working_title: string;
    imdb_id: string;
    content_type: number | null;
  }>;
  created_by?: string;
  created_at?: string;
}

export interface DuplicateDecisionPayload {
  decisions: DuplicateDecisionRequest[];
  sync?: boolean;
}